
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "Pagination",
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:currentPage", "change"],
  setup(props, { emit }) {
    // 计算总页数
    const totalPages = computed(() => Math.ceil(props.total / props.pageSize));

    // 是否使用小尺寸
    const isSmall = computed(() => props.small || window.innerWidth < 768);

    // 计算显示的页码
    const displayedPages = computed(() => {
      const current = props.currentPage;
      const total = totalPages.value;
      const arr: (number | string)[] = [];

      if (total <= 7) {
        // 总页数较少时，显示所有页码
        for (let i = 1; i <= total; i++) {
          arr.push(i);
        }
      } else {
        // 总页数较多时，显示部分页码
        arr.push(1);

        if (current - 3 > 1) {
          arr.push("...");
        }

        // 当前页附近的页码
        for (
          let i = Math.max(2, current - 2);
          i <= Math.min(current + 2, total - 1);
          i++
        ) {
          arr.push(i);
        }

        if (current + 3 < total) {
          arr.push("...");
        }

        arr.push(total);
      }

      return arr;
    });

    // 页码改变处理
    const handlePageChange = (page: number) => {
      if (page < 1 || page > totalPages.value) return;
      emit("update:currentPage", page);
      emit("change", page);
    };

    return {
      totalPages,
      isSmall,
      displayedPages,
      handlePageChange,
    };
  },
});
